var map = {
	"./decidim/avatar-multiuser.png": 808,
	"./decidim/brands/google.svg": 7671,
	"./decidim/cc-badge.png": 9714,
	"./decidim/decidim-logo.svg": 7274,
	"./decidim/default-avatar.svg": 6918,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 8730,
	"./decidim/icons.svg": 5993,
	"./decidim/pattern.png": 8486,
	"./decidim/placeholder-card-g.svg": 7531,
	"./decidim/placeholder-card-l.svg": 3824,
	"./decidim/placeholder.jpg": 3108,
	"./decidim/remixicon.symbol.svg": 4735,
	"./decidim/vendor/leaflet/layers-2x.png": 818,
	"./decidim/vendor/leaflet/layers.png": 6089,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 6032,
	"./decidim/vendor/leaflet/marker-icon.png": 2991,
	"./decidim/vendor/leaflet/marker-shadow.png": 4780,
	"./decidim/vendor/social-share-button/douban.svg": 398,
	"./decidim/vendor/social-share-button/email.svg": 9867,
	"./decidim/vendor/social-share-button/facebook.svg": 6093,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 2391,
	"./decidim/vendor/social-share-button/hacker_news.svg": 6047,
	"./decidim/vendor/social-share-button/linkedin.svg": 7427,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 6988,
	"./decidim/vendor/social-share-button/pinterest.svg": 3837,
	"./decidim/vendor/social-share-button/reddit.svg": 237,
	"./decidim/vendor/social-share-button/telegram.svg": 2196,
	"./decidim/vendor/social-share-button/tumblr.svg": 651,
	"./decidim/vendor/social-share-button/twitter.svg": 890,
	"./decidim/vendor/social-share-button/vkontakte.svg": 5284,
	"./decidim/vendor/social-share-button/wechat.svg": 3183,
	"./decidim/vendor/social-share-button/whatsapp.svg": 3071,
	"./decidim/vendor/social-share-button/x.svg": 4603,
	"./decidim/vendor/social-share-button/xing.svg": 4109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4845;